import React, { forwardRef } from "react";
import { Link } from "react-router-dom";

import { Icons, Logos } from "../../data/Assets";

import { SearchInput } from "../reusables/Inputs";
import { SVGIcon } from "../wrappers/SVGIcon";
import { ImageAsset } from "../wrappers/ImageAsset";

const Header = forwardRef<HTMLDivElement>((_, ref) => {
    return (
        <div ref={ref} className="immersion__header">
            <div className="immersion__header__logo_sec">
                <Link to="/" className='immersion__header__logo'>
                    <ImageAsset src={Logos.Logo} alt="" className='fit_asset_max' />
                </Link>
            </div>
            <div className="immersion__header__search_sec">
                <SearchInput />
            </div>
            <div className="immersion__header__menu_sec">
                <button className="header_icon_btn">
                    <SVGIcon src={Icons.Bell2Fill} color="grey" />
                </button>
                <button className="header_icon_btn">
                    <SVGIcon src={Icons.Chat3Fill} color="grey" />
                </button>
                <button className="header_icon_btn">
                    <SVGIcon src={Icons.Calendar2} color="grey" />
                </button>
            </div>
        </div>
    );
});

export default Header;